import type { ColumnDef } from '../projects/projectsColumns';

export const sitesColumns: ColumnDef[] = [
  { field: 'SiteName', headerName: 'Site Name', sortable: true, flex: 1.5 },
  { field: 'SiteCity', headerName: 'City', sortable: true, flex: 1 },
  { field: 'Province', headerName: 'Province', sortable: true, flex: 0.9 },
  { field: 'Country', headerName: 'Country', sortable: true, flex: 0.9 },
  { field: 'ProjectCount', headerName: 'Projects', sortable: true, width: 90 },
  { field: 'LocationCount', headerName: 'Locations', sortable: true, width: 100 },
  { field: 'sysLastModifiedDate', headerName: 'Last Modified', sortable: true, width: 115 },
];

export const siteLocationsColumns: ColumnDef[] = [
  { field: 'LocationId', headerName: 'Location ID', sortable: true, width: 130 },
  { field: 'LocationName', headerName: 'Location Name', sortable: true, flex: 1.2 },
  { field: 'LocationType', headerName: 'Type', sortable: true, width: 100 },
  { field: 'ProjectName', headerName: 'Project', sortable: true, flex: 1 },
  { field: 'SampleCount', headerName: 'Samples', sortable: true, width: 90 },
];
